export default function StreamSettings() {
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <h2 style={{ margin: 0 }}>Stream Settings</h2>
      <p style={{ margin: 0, lineHeight: 1.6 }}>
        Backend YouTube OAuth, broadcast scheduling, and WebRTC relay settings will live here after the service endpoints are added.
      </p>
    </div>
  );
}
